import { render, staticRenderFns } from "./LedgerListFilters.vue?vue&type=template&id=45b66a1f&"
import script from "./LedgerListFilters.vue?vue&type=script&lang=js&"
export * from "./LedgerListFilters.vue?vue&type=script&lang=js&"
import style0 from "./LedgerListFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports